import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

/**
 * @deprecated Use { Spinner } from `@companycam/slab-web` instead
 *
 * https://slab-web.cocam.co/?path=/docs/spinner--docs
 */

const Spinner = (props) => {
  const classes = cx('spinner', {
    large: props.large,
  });

  return (
    <div className={classes}>
      <div />
      <div />
    </div>
  );
};

export default Spinner;

Spinner.propTypes = {
  large: PropTypes.bool,
};
